import { lazy, memo } from 'react'

import { useAppStoreSelector } from '../hooks/useAppStoreSelector'
import {
  selectAppStatus,
  selectIsRootLauncherJourney,
  selectIsTemplate,
  selectJourneyOrRoot
} from '../store/selectors/config'
import { selectCurrentStep, selectHasDesign } from '../store/selectors/runtime'
import { APP_STATUS } from '../store/types/enums'

import JourneyApp from './JourneyApp'
import { SpinnerPage } from './SpinnerPage'

const LauncherApp = lazy(() => import('./LauncherApp'))

export const AppComponent = memo(() => {
  const appStatus = useAppStoreSelector(selectAppStatus)
  const isLauncher = useAppStoreSelector(selectIsRootLauncherJourney)
  const currentStep = useAppStoreSelector(selectCurrentStep)
  const hasDesign = useAppStoreSelector(selectHasDesign)
  const isTemplate = useAppStoreSelector((state) =>
    selectIsTemplate(state, selectJourneyOrRoot)
  )

  if (
    appStatus !== APP_STATUS.READY ||
    // prevents changing the look and feel after the initial render
    (!hasDesign && !isTemplate)
  ) {
    return <SpinnerPage />
  }

  if (isLauncher) {
    return <LauncherApp />
  }

  if (!currentStep) {
    return <SpinnerPage />
  }

  return <JourneyApp />
})

AppComponent.displayName = 'AppComponent'
